module.exports = __webpack_public_path__ + "img/summons.a61098bf.jpg";